import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

// Enable debug mode (set to false in production)
const DEBUG_MODE = true;

// Track page views
export const trackPageView = (pageName, path) => {
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    page_path: path,
    timestamp: new Date().toISOString(),
    debug_mode: DEBUG_MODE
  });
};

// Track navigation clicks
export const trackNavigation = (destination) => {
  logEvent(analytics, 'navigation_click', {
    destination: destination,
    timestamp: new Date().toISOString()
  });
};

// Track main screen clicks
export const trackMainScreenClick = (elementName) => {
  logEvent(analytics, 'main_screen_click', {
    element: elementName,
    timestamp: new Date().toISOString()
  });
};

// Track product/service clicks (for "Livro" button)
export const trackProductClick = (productName) => {
  logEvent(analytics, 'product_click', {
    product_name: productName,
    timestamp: new Date().toISOString()
  });
};

// Track book menu interactions
export const trackBookMenuOpen = () => {
  logEvent(analytics, 'book_menu_opened', {
    timestamp: new Date().toISOString()
  });
};

// Track individual book purchase button clicks
export const trackBookPurchaseClick = (platform, format, country) => {
  logEvent(analytics, 'book_purchase_click', {
    platform: platform,      // UiClap, Hotmart, Amazon
    format: format,          // Físico, Digital
    country: country,        // Brasil, EUA, Portugal
    timestamp: new Date().toISOString()
  });
};

// Track WhatsApp popup actions
export const trackWhatsAppPopup = (action, serviceName = null) => {
  logEvent(analytics, 'whatsapp_popup_action', {
    action: action, // 'open', 'confirm', 'cancel'
    service_name: serviceName,
    timestamp: new Date().toISOString()
  });
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  logEvent(analytics, 'social_click', {
    platform: platform,
    timestamp: new Date().toISOString()
  });
};

// Track service card interactions
export const trackServiceInteraction = (serviceName, action) => {
  logEvent(analytics, 'service_interaction', {
    service_name: serviceName,
    action: action, // 'view', 'click', 'whatsapp_click'
    timestamp: new Date().toISOString()
  });
};

// Track sessao autocuidado WhatsApp redirect clicks
export const trackSessaoAutocuidadoClick = (source = 'direct') => {
  logEvent(analytics, 'sessao_autocuidado_whatsapp_redirect', {
    service_type: 'autocuidado',
    redirect_destination: 'whatsapp',
    traffic_source: source, // google, instagram, direct, etc.
    timestamp: new Date().toISOString(),
    debug_mode: DEBUG_MODE
  });
};
